/* Quote band: one slide at a time, arrows + dots, wrapping at both ends. */
(function () {
  function setup(root) {
    if (root.dataset.blQuoteReady === '1') return;
    root.dataset.blQuoteReady = '1';

    var slides = Array.prototype.slice.call(root.querySelectorAll('.bl-quote__slide'));
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-bl-quote-dot]'));
    if (slides.length < 2) return;

    var index = 0;

    function show(i) {
      index = (i + slides.length) % slides.length;
      slides.forEach(function (el, n) {
        if (n === index) el.setAttribute('data-active', '');
        else el.removeAttribute('data-active');
      });
      dots.forEach(function (el, n) {
        if (n === index) el.setAttribute('data-active', '');
        else el.removeAttribute('data-active');
      });
    }

    var prev = root.querySelector('[data-bl-quote-prev]');
    var next = root.querySelector('[data-bl-quote-next]');
    if (prev) prev.addEventListener('click', function () { show(index - 1); });
    if (next) next.addEventListener('click', function () { show(index + 1); });
    dots.forEach(function (dot) {
      dot.addEventListener('click', function () { show(parseInt(dot.dataset.blQuoteDot, 10) || 0); });
    });

    show(0);
  }

  function init() { document.querySelectorAll('[data-bl-quote]').forEach(setup); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
